"use client";

import {
	Carousel,
	CarouselContent,
	CarouselDots,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
	CarouselThumbnails,
} from "@commerce-frontend/ui/components/Carousel/Carousel";
import { BREAKPOINTS } from "@commerce-frontend/ui/tailwind.config";
import { AssetImage } from "~/components/AssetImage/AssetImage";

type Props = {
	images: { url: string; alt?: string | null }[];
};

export const ProductImageSlider = ({ images }: Props) => {
	return (
		<>
			<Carousel opts={{ slidesToScroll: "auto" }}>
				<div className="relative lg:mb-xl">
					<CarouselContent>
						{images.map((image, index) => (
							<CarouselItem className="" key={image?.url}>
								<article className="flex shrink-0 flex-col">
									<picture className="w-full overflow-hidden">
										{image.url ? (
											<AssetImage
												width={600}
												height={600}
												data={{
													filename: image.url,
													alt: image.alt,
												}}
												loading={index === 0 ? "eager" : "lazy"}
												sizes={`(min-width: ${BREAKPOINTS.lg}) 600px, 100vw`}
												className="size-full object-contain"
											/>
										) : undefined}
									</picture>
								</article>
							</CarouselItem>
						))}
					</CarouselContent>
					<CarouselPrevious className="hidden lg:flex" />
					<CarouselNext className="hidden lg:flex" />
					<CarouselDots className="mt-xl lg:hidden" />
				</div>
				{images.length > 1 ? (
					<div className="hidden lg:flex">
						<CarouselThumbnails images={images} />
					</div>
				) : null}
			</Carousel>
		</>
	);
};
